type HttpMethod = 'GET' | 'POST';

function transformJson(this: any, key: string, value: any) {
    if (key && key.length >= 2 && key.indexOf('@') === 0) {
        this[key.substring(1)] = new Date(value);
        delete this[key];
        return;
    }

    return value;
}

export function request<T>(method: HttpMethod, url: string, body?: any) {
    return new Promise<T>((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.addEventListener('error', error => {
            reject(error);
        });

        xhr.addEventListener('load', () => {
            try {
                const { response, status } = xhr;

                if (status !== 200) {
                    try {
                        reject(JSON.parse(response));
                    } catch {
                        reject(response);
                    }
                    return;
                }

                if (!response) {
                    resolve(undefined);
                    return;
                }

                const json = JSON.parse(response, transformJson);
                resolve(json);
            } catch (ex) {
                reject(ex);
            }
        });

        xhr.open(method, url, true);

        if (body) {
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.send(JSON.stringify(body));
        } else {
            xhr.send();
        }
    });
}

export async function get<T>(url: string): Promise<T> {
    return await request<T>('GET', url);
}

export async function post<T>(url: string, body: any): Promise<T> {
    return await request<T>('POST', url, body);
}